import { render, staticRenderFns } from "./ListadoEventosImagen.vue?vue&type=template&id=894fc424&scoped=true"
import script from "./ListadoEventosImagen.vue?vue&type=script&setup=true&lang=js"
export * from "./ListadoEventosImagen.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ListadoEventosImagen.vue?vue&type=style&index=0&id=894fc424&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894fc424",
  null
  
)

export default component.exports